import { ReactNode } from 'react';

import AgentIcon from '@assets/buttons-icons/agents-button.svg?react';
import IntegrationIcon from '@assets/buttons-icons/integrations.svg?react';
import LightBulbIcon from '@assets/buttons-icons/lightblub.svg?react';
import UploadIcon from '@assets/buttons-icons/upload.svg?react';
import VideoAILineIcon from '@assets/buttons-icons/video-ai-line.svg?react';
import palette from '@lib/core/src/theme/palette';

import { ChecklistItemDto, ChecklistItemDtoStatus } from '@/api/generated';

type CheckListConfig = Required<ChecklistItemDto> & {
  icon?: ReactNode;
  info?: string;
  videoLink?: string;
};

export enum CheckListEnumTitles {
  IntegrateGoogleMicrosoft = 'Integrate Google / Microsoft',
  UploadAvatar = 'Upload avatar',
  ActivateOneAgent = 'Activate at least one agent',
  ActivateOneTemplate = 'Activate one template',
  ApproveBotToAMeeting = 'Approve bot to a meeting'
}

export const checkListConfig: CheckListConfig[] = [
  {
    title: CheckListEnumTitles.IntegrateGoogleMicrosoft,
    status: ChecklistItemDtoStatus.inProgress,
    icon: <IntegrationIcon fontSize="20px" color={palette.grey[500]} />,
    info: '🔗 Connect your Google or Microsoft account to enable calendar sync, email actions, and more.',
    videoLink:
      'https://journey-public-resources.s3.us-east-2.amazonaws.com/videos/onboarding/Connect_Your_Calendar.mp4'
  },
  {
    title: CheckListEnumTitles.UploadAvatar,
    status: ChecklistItemDtoStatus.inProgress,
    icon: <UploadIcon fontSize="20px" color={palette.grey[500]} />,
    info: '🧑‍🎨 Add your personal touch by uploading a profile picture. This helps personalize your agent interactions.',
    videoLink:
      'https://journey-public-resources.s3.us-east-2.amazonaws.com/videos/onboarding/Upload_your_Avatar.mp4'
  },
  {
    title: CheckListEnumTitles.ActivateOneAgent,
    status: ChecklistItemDtoStatus.inProgress,
    icon: <AgentIcon fontSize="20px" color={palette.grey[500]} />,
    info: '🕹️ Explore the Agent Hub to discover, configure, and activate powerful AI agents for your needs.',
    videoLink:
      'https://journey-public-resources.s3.us-east-2.amazonaws.com/videos/onboarding/AI_Agents.mp4'
  },
  {
    title: CheckListEnumTitles.ActivateOneTemplate,
    status: ChecklistItemDtoStatus.inProgress,
    icon: <LightBulbIcon fontSize="20px" color={palette.grey[500]} />,
    info: '📄 Kickstart your AI agent with a ready-to-use template tailored for common workflows.',
    videoLink:
      'https://journey-public-resources.s3.us-east-2.amazonaws.com/videos/onboarding/Activate_a_Meeting_Template.mp4'
  },
  {
    title: CheckListEnumTitles.ApproveBotToAMeeting,
    status: ChecklistItemDtoStatus.inProgress,
    icon: <VideoAILineIcon fontSize="20px" color={palette.grey[500]} />,
    info: '📅 Let your agent join a meeting via Recall, so it can transcribe, summarize, and follow up for you.',
    videoLink:
      'https://journey-public-resources.s3.us-east-2.amazonaws.com/videos/onboarding/Journey_AI_Bot_Joining_Meetings.mp4'
  }
];

export const checkListConfigByTitle = checkListConfig.reduce<
  Record<string, Omit<CheckListConfig, 'title'>>
>((acc, item) => {
  const { title, ...rest } = item;
  // eslint-disable-next-line no-param-reassign
  acc = {
    ...acc,
    [title]: rest
  };
  return acc;
}, {});
